import React, {useCallback} from 'react';
import {useDispatch, useSelector} from 'react-redux';

import {type PaginationChangeHandler, PaginationStripe} from '@pb/kit-component-pagination';

import {
    accessManagementUsersPaginationSelector,
    accessManagementUsersTotalCountSelector,
    changePage,
    changePageSize,
} from '../service/access-management-users.slice';


export const AccessManagementPagination: React.FC = () => {
    const dispatch = useDispatch();
    const pagination = useSelector(accessManagementUsersPaginationSelector);
    const totalCount = useSelector(accessManagementUsersTotalCountSelector);

    const onChangePageSize = useCallback((_currentPage: number, pageSize: number) => {
        dispatch(changePageSize(pageSize));
        window.scrollTo(0, 0);
    }, [dispatch]);

    const onPaginationChange = useCallback<PaginationChangeHandler>(({currentPage}) => {
        dispatch(changePage(currentPage));
    }, [dispatch]);

    return (
        <PaginationStripe
            goToPage={true}
            pageSize={pagination?.size ?? 25}
            totalCount={totalCount}
            currentPage={pagination?.page ?? 1}
            onPaginationChange={onPaginationChange}
            onChangePaginationSize={onChangePageSize}
            sizeSwitcherPosition="LEFT"
            sizeSwitcherType="ONLY_PAGE_SIZE"
            sizes={[10, 25, 50, 100, 250]}
        />
    );
};
